import AddUserModalSendNotification from './component'

export default AddUserModalSendNotification
